import { CLASSROOM_CONSULTATIONS } from "config/apiPaths"
import { generatePath } from "react-router-dom";
import { baseApi } from 'utils/axios/baseApi';

const classroomConsultation = baseApi.injectEndpoints({
    endpoints: (builder) => ({
        classroomConsultationsList: builder.query({
            query: ({ search = "", assign_term = '', school_division = '', teacher = '', school = "", grade = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: `${CLASSROOM_CONSULTATIONS.LIST}`,
                data: { search, teacher: teacher?.value || "", assign_term: assign_term?.value, school_division: school_division?.value, page, limit, sort, status: status?.value, school: school?.value, grade: grade?.value }
            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["classroomConsultation"]
        }),
        classroomConsultationsFavUnfav: builder.mutation({
            query: ({ id, data }) => ({
                method: "PUT",
                url: `${CLASSROOM_CONSULTATIONS.FAV_UNFAV}/${id}`,
                data
            }),
            transformResponse: (response) => {
                return response.data;
            },
            invalidatesTags: ["classroomConsultation"]
        }),
        classroomConsultationsArchive: builder.mutation({
            query: ({ id, status }) => ({
                method: "PUT",
                url: `${generatePath(CLASSROOM_CONSULTATIONS.ARCHIEVE, { reportId: id, status })}`,
            }),
            transformResponse: (response) => {
                return response.data;
            },
            invalidatesTags: ["classroomConsultation"]
        }),
    }),
})

export const {
    useClassroomConsultationsListQuery,
    useClassroomConsultationsFavUnfavMutation,
    useClassroomConsultationsArchiveMutation
} = classroomConsultation;